import { ChevronsDown } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

function MouseIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M6 3m0 4a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4z" />
      <path d="M12 7l0 4" />
    </svg>
  );
}

export function ScrollIndicator() {
  const { t } = useI18n();
  return (
    <div className="flex flex-col items-center gap-0.5 animate-bounce cursor-default" aria-hidden="true">
      <MouseIcon className="w-6 h-6 sm:w-7 sm:h-7 text-zinc-400" />
      <ChevronsDown className="w-4 h-4 sm:w-5 sm:h-5 text-text-muted -mt-0.5" />
      <span className="text-[9px] font-semibold tracking-widest uppercase text-zinc-600 dark:text-zinc-400 mt-0.5">
        {t('landing', 'scroll_down') || 'Scroll'}
      </span>
    </div>
  );
}